import axios from '../axios';
// eslint-disable-next-line import/order
import useAxios, { configure } from 'axios-hooks';

configure({ axios });

export function useFollow(id) {
  const common = fundId => ({ url: `/api/v1/fund/${fundId}/follow` });
  const [state, q] = useAxios({ ...common(id), method: 'POST' }, { manual: true });
  const executeQuery = fundId => q(common(fundId));
  return [state, executeQuery];
}

export function useUnfollow(id) {
  const common = fundId => ({ url: `/api/v1/fund/${fundId}/unfollow` });
  const [state, q] = useAxios({ ...common(id), method: 'POST' }, { manual: true });
  const executeQuery = fundId => q(common(fundId));
  return [state, executeQuery];
}
